import React from 'react';
import { WorkShopComponent } from '../../components/WorkShopComponent';

export const WorkShop = () => {
    return <WorkShopComponent />;
};
